import moment from 'moment';
import type { NextAvailableStay } from './findNextAvailableStay';

const STAY_DATE_FORMAT = 'D MMM YYYY';

export const formatStayDates = (
  stay: NextAvailableStay
): { checkIn: string; checkOut: string } => ({
  checkIn: moment(stay.checkIn).format(STAY_DATE_FORMAT),
  checkOut: moment(stay.checkOut).format(STAY_DATE_FORMAT),
});
